module.exports = __webpack_public_path__ + "img/bgManutencao.fd9753f8.png";